import { takeLatest, put, call, select } from 'redux-saga/effects';

import { authError, resetPassword, resetPasswordError, signIn, signOut } from '../actions';

import { signInWithEmailPasswordFirebase, signOutFirebase, resetPasswordFirebase } from '../repository';

import { AuthAction, AuthResetInput, AuthSignInInput, AuthTypes } from '../types';

import * as authSelectors from '../selectors';

import strings from '../../../resources/strings';

export function* requestSignInEmailPasswordSaga(props: AuthAction<AuthSignInInput>): unknown {
    const email = props.payload.email;
    const password = props.payload.password;
    try {
        if (email && password) {
            const userCredentials = yield call(signInWithEmailPasswordFirebase, email, password);
            yield put(signIn(userCredentials));
        }
    } catch (err: unknown) {
        yield put(authError(strings.loginPage.errorMessage));
    }
}

export function* requestSignOutSaga(): unknown {
    try {
        const isLogged = yield select(authSelectors.isLogged);

        if (isLogged) {
            yield call(signOutFirebase);
        }
        yield put(signOut());
    } catch {
        yield put(signOut());
    }
}

export function* requestResetPasswordSaga(props: AuthAction<AuthResetInput>): unknown {
    const email = props.payload.email;
    try {
        if (email) {
            yield call(resetPasswordFirebase, email);
            yield put(resetPassword());
        }
    } catch (err: unknown) {
        yield put(resetPasswordError(err as string));
    }
}

export default [
    takeLatest(AuthTypes.REQUEST_SIGNIN_EMAIL_PASSWORD, requestSignInEmailPasswordSaga),
    takeLatest(AuthTypes.REQUEST_SIGNOUT, requestSignOutSaga),
    takeLatest(AuthTypes.REQUEST_RESET_PASSWORD, requestResetPasswordSaga),
];
